import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { TiTicket } from 'react-icons/ti';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
};

function EventStatus({ event, settings, className = '' }) {
  if (!event.has('tickets')) return null;
  const tickets = event.get('tickets', []) || [];
  const showOnlineText = settings.get('showOnlineText', false);
  const isOnlineEvent = event.get('online_event');
  if (tickets.size === 0) return <span />;
  const noAvailableTickets = tickets.every((n) => n.get('on_sale_status') === 'UNAVAILABLE');
  const availableTickets = tickets.some((n) => n.get('on_sale_status') === 'AVAILABLE');
  const soldOutTickets = tickets.every((n) => n.get('on_sale_status') === 'SOLD_OUT');
  const notYetOnSaleTickets = tickets.every((n) => n.get('on_sale_status') === 'NOT_YET_ON_SALE');

  const soldOut = settings.get('autoTranslateEvent') ? <FormattedMessage id="sold-out" defaultMessage="Sold Out" /> : settings.get('soldOutText');

  const postponed = settings.get('autoTranslateEvent') ? (
    <FormattedMessage id="postponed" defaultMessage="Postponed" />
  ) : (
    settings.get('postponedText')
  );

  const onSale = settings.get('autoTranslateEvent') ? <FormattedMessage id="on-sale" defaultMessage="On Sale" /> : settings.get('onSaleText');
  const onlineEventText = settings.get('autoTranslateEvent') ? (
    <FormattedMessage id="online-event-text" defaultMessage="Online" />
  ) : (
    settings.get('onlineEventText')
  );
  const notYet = settings.get('autoTranslateEvent') ? (
    <FormattedMessage id="no-yet" defaultMessage="Not On Sale Yet" />
  ) : (
    settings.get('notYetOnSale')
  );

  const getStatusText = () => {
    if (soldOutTickets) {
      return soldOut;
    }
    if (notYetOnSaleTickets) {
      return notYet;
    }
    if (availableTickets) {
      return onSale;
    }
    return postponed;
  };

  const unavailable = noAvailableTickets || soldOutTickets || notYetOnSaleTickets;
  return (
    <div style={{ display: 'flex', marginRight: 10, alignItems: 'center', margin: '2px 0' }} className={className}>
      <TiTicket size={25} style={{ marginRight: 5 }} className={`event-status-${unavailable ? 'unavailable' : 'available'}`} />
      <div className={`event-status-${unavailable ? 'unavailable' : 'available'}`}>{getStatusText()}</div>
      {showOnlineText && isOnlineEvent && (
        <div className="online-event-text" style={{ marginLeft: 7 }}>
          {onlineEventText}
        </div>
      )}
    </div>
  );
}

EventStatus.propTypes = propTypes;

export default EventStatus;
